import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {DocumentModel} from '../../../models/document.model';
import {AlertController, IonContent, ModalController} from '@ionic/angular';
import {CustomerModel} from '../../../models/customer.model';
import {SiteModel} from '../../../models/site.model';
import {ContactModel} from '../../../models/contact.model';
import {LokijsService} from '../../../services/database/lokijs.service';
import {FindGeoLocationService} from '../../../services/find-geo-location.service';
import {ConfigurationService} from '../../../services/configuration.service';
import {PersistDocumentService} from '../../../services/persist-document.service';
import {ValidateDocumentService} from '../../../services/validate-document.service';
import {FindLiveConsumableLinesService} from '../../../services/find-live-consumable-lines.service';
import {PhotoDTOModel} from '../../../models/photoDTO.model';
import {DetaillineDTOModel} from '../../../models/detaillineDTO.model';
import {ConsumablesReturnPage} from '../../consumables-return/consumables-return.page';

@Component({
    selector: 'app-return-health-care',
    templateUrl: './offhire-health-care.page.html',
    styleUrls: ['./offhire-health-care.page.scss'],
})
export class OffhireHealthCarePage implements OnInit {

    @Input() document: DocumentModel;
    @ViewChild('content') content: IonContent;
    documentTemp: DocumentModel;

    constructor(private customer: CustomerModel,
                private site: SiteModel,
                private contactModel: ContactModel,
                private sigContactModel: ContactModel,
                private alertController: AlertController,
                private modalController: ModalController,
                private loki: LokijsService,
                private findGeoLocation: FindGeoLocationService,
                private config: ConfigurationService,
                private persistDocService: PersistDocumentService,
                private validateDoc: ValidateDocumentService,
                private findLiveConsumableLines: FindLiveConsumableLinesService) {
    }

    ngOnInit() {
        this.documentTemp = JSON.parse(JSON.stringify(this.document));
    }

    ionViewDidEnter() {
        this.content.scrollToTop(200);
    }


    listenDocument(event: DocumentModel) {
        this.documentTemp = event;
        if (!(this.documentTemp.documentType === 2 || this.documentTemp.documentType === 3)) {
            this.documentTemp.documentType = 0;
        }
        if (!(this.documentTemp.photosURL)) {
            this.documentTemp.photosURL = new Array<PhotoDTOModel>();
        }
    }

    listenCustomer(event) {
        this.documentTemp.customer = event;
        this.documentTemp.contact = new ContactModel();
        this.documentTemp.signatureContact = new ContactModel();
        this.documentTemp.site = new SiteModel();
        this.documentTemp.signature = null;
        this.documentTemp.detailLines = new Array<DetaillineDTOModel>();
    }

    listenSignature(event: string) {
        if (event) {
            this.documentTemp.queuedToOperatorId = null;
        }
    }

    async saveReturn() {
        const consumableLines = await this.findLiveConsumableLines.checkDoc(this.documentTemp);
        if (consumableLines && consumableLines.length > 0) {
            const alert = await this.alertController.create({
                header: 'Consumables Present in contract',
                message: 'Do you want to add consumables to return?',
                backdropDismiss: false,
                buttons: [
                    {
                        text: 'No',
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {
                        }
                    }, {
                        text: 'Yes',
                        handler: () => {
                            this.openConsumablesModal(consumableLines);
                        }
                    }
                ]
            });
            await alert.present();
        } else {
            await this.finishSaveReturn();
        }
    }

    async openConsumablesModal(consumableLines) {
        const modal = await this.modalController.create({
            component: ConsumablesReturnPage,
            cssClass: 'modal-fullscreen',
            componentProps: {
                document: this.documentTemp,
                consumableLines: consumableLines
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
                this.finishSaveReturn();
            }
        });
        return await modal.present();
    }

    async finishSaveReturn() {
        if (!this.validateDoc.isValid(this.documentTemp)) {
            return;
        } else {

            this.checkDates();
            this.document = JSON.parse(JSON.stringify(this.documentTemp));
            await this.persistDocService.persistDocument(this.document);
            await this.modalController.dismiss(this.document);
        }
    }

    checkDates() {
        for (const line of this.documentTemp.detailLines) {
            line.toDate = this.documentTemp.scheduledDate;
        }
    }


    async cancelReturn() {
        if (JSON.stringify((this.document)) !== JSON.stringify(this.documentTemp)) {
            const alert = await this.alertController.create({
                message: 'Do you want to cancel the Return?',
                backdropDismiss: false,
                buttons: [
                    {
                        text: 'No',
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {
                        }
                    }, {
                        text: 'Yes',
                        handler: () => {
                            this.modalController.dismiss();
                        }
                    }
                ]
            });
            await alert.present();
        } else {
            this.modalController.dismiss();
        }
    }
}
